export class ListInventoryBackupRegionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<CloudRegion>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryBackupRegionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
